import AppService from "./app-service"

const path = "cert-complement-requests"

export default class CertComplementRequestService extends AppService {

  constructor() {
    super({ path })
  }

  static get STATUS() {
    return {
      waiting: { icon: "clock orange icon", description: "Aguardando" },
      in_progress: { icon: "sync blue icon", description: "Em andamento" },
      finished: { icon: "check circle green icon", description: "Finalizado" },
    }
  }

  filter(data) {
    return this.http.post(`${path}/filter`, data)
  }

  countUserPendingRequests(userId) {
    return this.http.get(`count-pending-cert-complement-requests?userId=${userId}`).then((response) => response.count)
  }
}